// removed by extract-text-webpack-plugin
module.exports = {"tab":"_3uGtzkUV6F6YPnw0c30Xdf","tab-item":"_366r5JFQLFtwXDxJ9mULak","active":"_1ojatZg-ibj_rlIsLPLfXd","icon":"_3dzV9g7eo6kjAb3jUm0PKy"};